import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  BULK_ACTION_FOOTER_OBJECTS,
  BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS,
  BULK_ACTION_OBJ_USERS,
  getBulkActionFooterBtns,
} from '../constant';

function BulkActionEndDateSubTitle({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);

  const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
  const buttonObjectsForTotal = getBulkActionFooterBtns(
    campaignType,
    reassignConfigMap
  )[buttonKey]?.objectsToTotal;

  const tempSubtitleText = buttonObjectsForTotal
    ?.filter((key) => bulkFooterStats[key] > 0)
    .map((key) => {
      const messageKey =
        BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS[
          `${BULK_ACTION_FOOTER_OBJECTS[key]}${
            bulkFooterStats[key] > 1 ? 's' : ''
          }`
        ];

      return `${
        messages.messageKey || localize(intl, getMessageKey(messageKey))
      } (${bulkFooterStats[key]})`;
    });

  if (!tempSubtitleText) return '';

  if (tempSubtitleText?.length === 0) {
    return (
      messages.CERTS_BULK_NOTHING_SELECTED ||
      localize(intl, getMessageKey('CERTS_BULK_NOTHING_SELECTED'))
    );
  }

  if (tempSubtitleText?.length === 1) {
    if (!bulkFooterStats?.[BULK_ACTION_OBJ_USERS]) {
      return `${
        messages.CERTS_BULK_CED_SELECTED ||
        localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
      } ${tempSubtitleText[0]}. ${
        messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
        localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
      } ${
        messages['BULKACTION.common.reject.INLINE_MESSAGE.ATTESTATIONS'] ||
        localize(intl, getMessageKey('BULKACTION.common.reject.INLINE_MESSAGE'))
      }`;
    }

    return `${
      messages.CERTS_BULK_CED_SELECTED ||
      localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
    } ${tempSubtitleText[0]}. ${
      messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
      localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
    }`;
  }

  const subtitle = tempSubtitleText
    .slice(0, tempSubtitleText.length - 1)
    .join(', ');

  if (!bulkFooterStats?.[BULK_ACTION_OBJ_USERS]) {
    return `${
      messages.CERTS_BULK_CED_SELECTED ||
      localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
    } ${subtitle} ${
      messages.CERTS_BULK_AND || localize(intl, getMessageKey('CERTS_BULK_AND'))
    } ${tempSubtitleText[tempSubtitleText.length - 1]}. ${
      messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
      localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
    } ${
      messages['BULKACTION.common.reject.INLINE_MESSAGE.ATTESTATIONS'] ||
      localize(intl, getMessageKey('BULKACTION.common.reject.INLINE_MESSAGE'))
    }`;
  }

  return `${
    messages.CERTS_BULK_CED_SELECTED ||
    localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
  } ${subtitle} ${
    messages.CERTS_BULK_AND || localize(intl, getMessageKey('CERTS_BULK_AND'))
  } ${tempSubtitleText[tempSubtitleText.length - 1]}. ${
    messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
    localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
  }`;
}

BulkActionEndDateSubTitle.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionEndDateSubTitle.defaultProps = { bulkFooterStats: {} };

export default BulkActionEndDateSubTitle;
